import { useState } from "react";

const chip = (on) => `inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${on ? "bg-white text-slate-900 border-white" : "border-white/30 text-white/80 hover:border-white/60"}`;

// Quem pode ser convidado: equipa (consultor, gestão) e clientes com email.
export function invitePeople(p) {
  const team = [[p.consultant_name, p.consultant_email, "Consultor"], [p.gestao?.name, p.gestao?.email, "Gestão"]];
  const clients = [...(p.sellers || []).map((s) => [s.name, s.email, "Vendedor"]), ...(p.buyers || []).map((b) => [b.name, b.email, "Comprador"])];
  return [...team.map((x) => [...x, "interno"]), ...clients.map((x) => [...x, "externo"])]
    .filter(([n, e]) => n && e).map(([name, email, role, side]) => ({ name, email, role, side }));
}

export function DeedInvite({ p, guests, setGuests }) {
  const [extra, setExtra] = useState("");
  const people = invitePeople(p);
  const on = (e) => guests.some((g) => g.email === e);
  const toggle = (x) => setGuests(on(x.email) ? guests.filter((g) => g.email !== x.email) : [...guests, x]);
  const addExtra = () => {
    const mails = extra.split(/[\s,;]+/).filter((m) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(m) && !on(m));
    if (mails.length) setGuests([...guests, ...mails.map((email) => ({ email, name: email, side: "externo" }))]);
    setExtra("");
  };
  return (
    <div className="space-y-2" data-testid="deed-invite">
      <div className="text-xs text-white/60">Convidar</div>
      <div className="flex flex-wrap gap-1.5">
        {people.map((x) => <button type="button" key={x.email} onClick={() => toggle(x)} className={chip(on(x.email))} data-testid={`deed-invite-${x.role.toLowerCase()}`}>{x.name.split(" ")[0]} · {x.role}</button>)}
        {guests.filter((g) => !people.some((x) => x.email === g.email)).map((g) => <button type="button" key={g.email} onClick={() => toggle(g)} className={chip(true)} data-testid="deed-invite-extra-chip">{g.email} ×</button>)}
      </div>
      <div className="flex gap-2">
        <input value={extra} onChange={(e) => setExtra(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addExtra(); } }} placeholder="Outro email (ex.: notário, banco)"
          className="flex-1 min-w-0 h-9 rounded-lg px-3 text-sm text-slate-800 bg-white" data-testid="deed-invite-email" />
        <button type="button" onClick={addExtra} className="h-9 px-3 rounded-lg border border-white/40 text-xs font-semibold text-white hover:bg-white/10" data-testid="deed-invite-add">Adicionar</button>
      </div>
    </div>
  );
}
